import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react';
import {
  ClickWrapper,
  DarkText,
  FlexWrapper,
  GridBox,
  InfoWrapper,
  PurpleText
} from '../../../../theme/common_style';
import { ContentWrapper } from '../../common';
import PropTypes from 'prop-types';
import DetailsBox from './DetailsBox';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDeviceAssignDetails } from '../../../../services/api_collection';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import useDepartmentOptions from '../../../../hooks/useDepartmentOptions';
import useDesignationOptions from '../../../../hooks/useDesignationOptions';
import { NoMilestone } from '../../../../theme/SvgIcons';
import AvatarImage from '../../../../components/common/AvatarImage';
import { checkPermission, getFullName, useWindowWide } from '../../../../utils/common_functions';
import { Button, Skeleton } from 'antd';
import { HmsInternalTabEnum, hmsStatusEnum, hmsTabEnum } from '../../../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { updateHmsTab, updateInternalHmsTab } from '../../../../redux/hms/HmsSlice';
import AssignDeviceModal from '../../AssignDeviceModal';
// import { updateHmsTab } from '../../../../redux/hms/HmsSlice';

const AssignedTo = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state?.HmsSlice?.HmsTab);
  const { id } = location.state || {};
  const { options: departmentOptions } = useDepartmentOptions();
  const [assignToDetails, setAssignToDetails] = useState(null);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const largeScreen = useWindowWide(950);
  const largeScreen1 = useWindowWide(660);
  const matchDepartment = departmentOptions?.find(
    (val) => val?.value == assignToDetails?.device?.[0]?.employee?.department
  );
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const canRead = checkPermission('Employee', 'read', permissions);
  const canCreate = checkPermission('HMS', 'create', permissions);
  const [addModal, setAddModal] = useState(false);

  const getFormattedDate = (ts) => {
    const timestamp = Number(ts);
    if (!timestamp || isNaN(timestamp)) return '-';
    const isInSeconds = timestamp.toString().length === 10;
    return dayjs(isInSeconds ? timestamp * 1000 : timestamp).format('DD MMM YYYY');
  };

  const fetchDesignation = async () => {
    if (matchDepartment) {
      const res = await useDesignationOptions(matchDepartment?.value);
      let obj = res.find(
        (item) => item?.id === assignToDetails?.device?.[0]?.employee?.designation
      );
      setDesignationOptions(obj);
    }
  };
  const fromattedData = [
    { key: 'Employee Name', value: assignToDetails?.device?.[0]?.employee?.first_name || 'N/A' },
    { key: 'Employee Id', value: assignToDetails?.device?.[0]?.employee?.emp_code || 'N/A' },
    { key: 'Designation', value: designationOptions?.designation || 'N/A' },
    { key: 'Role', value: assignToDetails?.device?.[0]?.employee?.role_id?.role || 'N/A' },
    { key: 'Department', value: matchDepartment?.label || 'N/A' },
    {
      key: 'Date Assigned',
      value: getFormattedDate(assignToDetails?.device?.[0]?.assign_date)
    }
  ];

  const hardwareData = [
    { key: 'Device Id', value: assignToDetails?.device_id },
    { key: 'Device Type', value: assignToDetails?.device_type },
    { key: 'Brand', value: assignToDetails?.brand },
    { key: 'Model', value: assignToDetails?.model },
    { key: 'Serial Number', value: assignToDetails?.serial_number }
  ];

  const specifications = [
    { key: 'CPU', value: assignToDetails?.cpu || 'N/A' },
    { key: 'RAM', value: assignToDetails?.ram || 'N/A' },
    { key: 'Storage', value: assignToDetails?.storage || 'N/A' },
    { key: 'Graphics', value: assignToDetails?.graphics || 'N/A' },
    { key: 'Oprating System', value: assignToDetails?.operating_system || 'N/A' },
    { key: 'MAC Address', value: assignToDetails?.macORip_address || 'N/A' },
    { key: 'Username', value: assignToDetails?.user_name || 'N/A' },
    { key: 'Password', value: assignToDetails?.password || 'N/A', isPassword: true }
  ];

  const handleGetDeviceDetails = async () => {
    setLoading(true);
    if (id && (activeTab == hmsTabEnum?.INVENTORY || activeTab == hmsTabEnum?.ASSIGNEE)) {
      let res = await getDeviceAssignDetails(id);
      if (res?.statusCode === 200) {
        setAssignToDetails(res?.data);
        setLoading(false);
      } else {
        if (res?.statusCode === 400 && res?.message) {
          navigate('/hms', { replace: true });
        }
        setAssignToDetails(null);
        toast.error(
          res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
        );
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    handleGetDeviceDetails();
  }, [activeTab]);

  useEffect(() => {
    fetchDesignation();
  }, [matchDepartment?.value]);

  return assignToDetails || loading ? (
    <div>
      <Title level={4} style={{ margin: '10px 0', textAlign: 'left' }}>
        Assigned To
      </Title>
      <FlexWrapper wrap={largeScreen ? 'nowrap' : 'wrap'} gap="10px" align="unset">
        <ContentWrapper padding="32px 40px" style={{ width: largeScreen ? 'fit-content' : '100%' }}>
          {loading ? (
            <Skeleton.Avatar active size={180} shape="circle" />
          ) : (
            <AvatarImage
              style={{ width: '180px', height: '180px' }}
              image={
                process.env.REACT_APP_S3_BASE_URL +
                'employee/profileImg/' +
                assignToDetails?.device?.[0]?.employee?.id +
                '.jpg'
              }
              name={getFullName(
                assignToDetails?.device?.[0]?.employee?.first_name,
                assignToDetails?.device?.[0]?.middle_name,
                assignToDetails?.device?.[0]?.employee?.last_name
              )}
            />
          )}
        </ContentWrapper>
        <ContentWrapper style={{ width: '100%' }}>
          <FlexWrapper align="start" wrap="nowrap" gap="10px" justify="start">
            <GridBox
              cols={largeScreen1 ? 2 : 1}
              style={{ width: '80%', textTransform: 'capitalize' }}>
              {fromattedData?.map((item, i) => (
                <InfoWrapper key={i}>
                  <span>{item?.key}</span>
                  {loading ? (
                    <Skeleton.Input
                      active
                      size="small"
                      style={{ width: 80, height: 16, margin: 0 }}
                    />
                  ) : (
                    <p>{item?.value}</p>
                  )}
                </InfoWrapper>
              ))}
            </GridBox>
            {canRead && loading ? (
              <Skeleton.Input active size="small" style={{ width: 150, height: 20, margin: 0 }} />
            ) : (
              canRead && (
                <ClickWrapper
                  onClick={() =>
                    navigate(`/view-employee`, {
                      state: {
                        id: assignToDetails?.device?.[0]?.employee?.id,
                        name: getFullName(
                          assignToDetails?.device?.[0]?.employee?.first_name,
                          assignToDetails?.device?.[0]?.middle_name,
                          assignToDetails?.device?.[0]?.employee?.last_name
                        )
                      }
                    })
                  }>
                  <PurpleText
                    style={{ textAlign: 'right', cursor: 'pointer', width: 'fit-content' }}>
                    View Employee details
                  </PurpleText>
                </ClickWrapper>
              )
            )}
          </FlexWrapper>
        </ContentWrapper>
      </FlexWrapper>
      {activeTab === hmsTabEnum?.ASSIGNEE && (
        <div>
          <FlexWrapper justify="space-between" gap="10px" margin="20px 0 0">
            <Title level={4} style={{ margin: 0 }}>
              Hardware Info
            </Title>
            <ClickWrapper
              onClick={() => {
                dispatch(updateHmsTab(hmsTabEnum?.INVENTORY));
                dispatch(updateInternalHmsTab(HmsInternalTabEnum?.HARDWARE_INFO));
                navigate(`/hms/details`, {
                  state: { hms: data?.device, id: id }
                });
              }}>
              <PurpleText style={{ cursor: 'pointer' }}>View Full Details</PurpleText>
            </ClickWrapper>
          </FlexWrapper>
          <ContentWrapper style={{ margin: '10px 0 12px' }}>
            <GridBox cols={5}>
              {hardwareData?.map((item, i) => (
                <InfoWrapper key={i}>
                  <span>{item?.key}</span>
                  {loading ? (
                    <Skeleton.Input
                      active
                      size="small"
                      style={{ width: 80, height: 16, margin: 0 }}
                    />
                  ) : (
                    <p>{item?.value}</p>
                  )}
                </InfoWrapper>
              ))}
            </GridBox>
          </ContentWrapper>
          <DetailsBox loading={loading} heading={'Specifications'} cols={3} data={specifications} />
        </div>
      )}
    </div>
  ) : (
    <>
      {addModal && (
        <AssignDeviceModal
          open={addModal}
          onClose={() => setAddModal(false)}
          handleDetails={handleGetDeviceDetails}
        />
      )}
      <FlexWrapper margin="60px 20px" direction="column">
        <NoMilestone />
        <Title level={5} style={{ margin: '10px 0 0' }}>
          No Assignee
        </Title>
        <DarkText weight="400">This device is not assigned to anyone yet.</DarkText>
        {canCreate && data?.status === hmsStatusEnum?.AVAILABLE && (
          <Button
            prefixCls="antCustomBtn"
            style={{ margin: '6px 0' }}
            onClick={() => setAddModal(true)}>
            + Add Assignee
          </Button>
        )}
      </FlexWrapper>
    </>
  );
};

AssignedTo.propTypes = {
  data: PropTypes.object
};

export default AssignedTo;
